import React from "react";
import "./Skills.css";
import { BsCode } from "react-icons/bs";
import { BiServer } from "react-icons/bi";
import { AiFillHtml5 } from "react-icons/ai";
import { FaCss3Alt, FaBootstrap, FaPython } from "react-icons/fa";
import {
  IoLogoReact,
  IoLogoNodejs,
  IoLogoJavascript,
  IoCode,
} from "react-icons/io5";
import { SiRedux, SiExpress, SiMongodb, SiDjango } from "react-icons/si";

const Skills = () => {
  return (
    <section className="skills__section section" id="skills">
      <h2 className="section__title">Skills</h2>
      <span className="section__subtitle">My Programming Skills</span>
      <div className="skills__container container">
        <div className="Skills__frontend">
          {/* Skills 1 */}
          <div className="skills__content">
            <div className="skills__header">
              <i className="skills__icons">
                <BsCode />
              </i>
              <div>
                <h1 className="skills__title">Frontend</h1>
              </div>
            </div>
            <div className="skills__list grid">
              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon">
                      <AiFillHtml5 />
                    </i>
                    <h3 className="skills__name-word"> HTML5</h3>
                  </h3>
                  <span className="skills_number">90%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__html"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon css__logo">
                      <FaCss3Alt />
                    </i>
                    <h3 className="skills__name-word"> CSS3</h3>
                  </h3>
                  <span className="skills_number">80%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__css"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon js__logo">
                      <IoLogoJavascript />
                    </i>
                    <h3 className="skills__name-word">Javascript</h3>
                  </h3>
                  <span className="skills_number">80%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__js"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon react__logo">
                      <IoLogoReact />
                    </i>
                    <h3 className="skills__name-word"> React</h3>
                  </h3>
                  <span className="skills_number">85%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__react"></span>
                </div>
              </div>
              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon redux__logo">
                      <SiRedux />
                    </i>
                    <h3 className="skills__name-word">Redux</h3>
                  </h3>
                  <span className="skills_number">80%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__redux"></span>
                </div>
              </div>
              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon boost__logo">
                      <FaBootstrap />
                    </i>
                    <h3 className="skills__name-word">Bootstrap </h3>
                  </h3>
                  <span className="skills_number">75%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__boot"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className="Skills__backend">
          {/* Skills 2 */}
          <div className="skills__content">
            <div className="skills__header">
              <i className="skills__icons">
                <BiServer />
              </i>
              <div>
                <h1 className="skills__title">Backend</h1>
              </div>
            </div>
            <div className="skills__list grid">
              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon node__logo">
                      <IoLogoNodejs />
                    </i>
                    <h3 className="skills__name-word">Node</h3>
                  </h3>
                  <span className="skills_number">85%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__node"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon express__logo">
                      <SiExpress />
                    </i>
                    <h3 className="skills__name-word">Express</h3>
                  </h3>
                  <span className="skills_number">80%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__express"></span>
                </div>
              </div>
              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon mongodb__logo">
                      <SiMongodb />
                    </i>
                    <h3 className="skills__name-word">MongoDB</h3>
                  </h3>
                  <span className="skills_number">80%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__mongodb"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon api__logo">
                      <IoCode />
                    </i>
                    <h3 className="skills__name-word"> REST API'S</h3>
                  </h3>
                  <span className="skills_number">90%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__rest"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon logo__python">
                      <FaPython />
                    </i>
                    <h3 className="skills__name-word">Python</h3>
                  </h3>
                  <span className="skills_number">85%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__python"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skills__name">
                    {" "}
                    <i className="skills__logo__icon django__logo">
                      <SiDjango />
                    </i>
                    <h3 className="skills__name-word">Django</h3>
                  </h3>
                  <span className="skills_number">80%</span>
                </div>
                <div className="skills__bar">
                  <span className="skills__percentage skills__django"></span>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
        </div>
      </div>
    </section>
  );
};

export default Skills;
